import Chart from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.plugins.unregister(ChartDataLabels);
Chart.defaults.global.defaultFontFamily = '"Noto Sans JP", sans-serif';



// ------------------
// Scale labels
// ------------------

const scaleLabels = (() => {

    const pluginDefaults = {
        top: 10,
        bottom: 10,
        labels: []
    };

    const labelDefaults = {
        fontSize: Chart.defaults.global.defaultFontSize,
        fontColor: Chart.defaults.global.defaultFontColor,
        fontFamily: Chart.defaults.global.defaultFontFamily,
        fontStyle: Chart.defaults.global.defaultFontStyle,
        lineHeight: Chart.defaults.global.defaultLineHeight
    };

    const draw = chart => {

        if (!chart.options.plugins.axesLabels) return;
        let options = {...pluginDefaults, ...chart.options.plugins.axesLabels};

        let labels = options.labels.map(label => {
            label = {...labelDefaults, ...label};
            label.scale = chart.options.scales.yAxes.find(axis => axis.id === label.yAxisID);
            label.offset = (label.scale.ticks.fontSize || chart.options.defaultFontSize) / 2;
            label.height = label.fontSize * label.lineHeight * label.value.length;
            return label;
        });

        const height = Math.max.apply(Math, labels.map(label => label.height));
        const offset = Math.max.apply(Math, labels.map(label => label.offset));
        const top = options.top + height + options.bottom + offset;

        if (top > chart.options.layout.padding.top) {
            chart.options.layout.padding.top = top;
            chart.update();
        }

        labels.forEach(label => {
            let x = 0;
            if (label.scale.position === 'left') x = chart.chartArea.left / 2;
            if (label.scale.position === 'right') x = chart.chartArea.right  + (chart.width - chart.chartArea.right) / 2;
            const h = label.fontSize * label.lineHeight;
            const y = options.top + (height - h * label.value.length) / 2;
            chart.ctx.textAlign = 'center';
            chart.ctx.textBaseline = 'top';
            chart.ctx.fillStyle = label.fontColor;
            chart.ctx.font = `${label.fontStyle} ${label.fontSize}px ${label.fontFamily}`;
            label.value.forEach((val, i) => chart.ctx.fillText(val, x, y + i * h));
        });

    };

    return {
        id: 'scaleLabels',
        afterDraw: draw
    }

})();



// ------------------
// Striped grid
// ------------------

const stripedGrid  = (() => {

    const defaults = {
        backgroundColor: '#CCC'
    };

    const draw = chart => {

        if (!chart.options.plugins.stripedGrid) return;

        const options = {...defaults, ...chart.options.plugins.stripedGrid};
        const scale = chart.scales[options.yAxisID];
        const num = Math.floor(scale.ticks.length / 2);
        const step = scale.height / scale.ticks.length;

        chart.ctx.fillStyle = options.backgroundColor;

        let offset, x, y, h, w;
        for (let i = 0; i <= num; i++) {
            offset = step * (2 * i + 1);
            w = chart.chartArea.right - chart.chartArea.left;
            h = step;
            x = chart.chartArea.left;
            y = chart.chartArea.bottom - offset;
            chart.ctx.fillRect(x, y, w, h);
        }

    };

    return {
        id: 'scaleLabels',
        beforeDraw: draw
    }

})();



// ------------------
// Exports
// ------------------

export {
    Chart,
    scaleLabels,
    stripedGrid,
    ChartDataLabels
}
